/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated';
import { addDependencies } from './dependenciesAdd.generated';
import { identityDependencies } from './dependenciesIdentity.generated';
import { invDependencies } from './dependenciesInv.generated';
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createExpm } from '../../factoriesAny.js';
export var expmDependencies = {
  absDependencies: absDependencies,
  addDependencies: addDependencies,
  identityDependencies: identityDependencies,
  invDependencies: invDependencies,
  multiplyDependencies: multiplyDependencies,
  typedDependencies: typedDependencies,
  createExpm: createExpm
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesExpm.generated.js
// module id = 1403
// module chunks = 0